/* Student surface: join a class by code, then for each class form/join a team
 * and start playing. */
import { useState } from 'react';
import { useClasses, useJoinClass } from '../../hooks/queries';
import { Button, Card, Field, Input, Spinner, EmptyNote } from '../../components/ui';
import { ApiError } from '../../lib/api';
import { ClassTeams } from './ClassTeams';

export function StudentDashboard() {
  const classes = useClasses();
  const join = useJoinClass();
  const [code, setCode] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    join.mutate({ joinCode: code }, { onSuccess: () => setCode('') });
  };

  return (
    <div className="space-y-6">
      <Card className="max-w-md">
        <h2 className="mb-2 text-sm font-semibold uppercase tracking-wide text-mut">Join a class</h2>
        <form onSubmit={submit} className="flex items-end gap-2">
          <div className="flex-1">
            <Field label="Join code">
              <Input
                required value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase())}
                placeholder="ABC123" className="font-mono tracking-widest"
              />
            </Field>
          </div>
          <Button type="submit" disabled={join.isPending}>{join.isPending ? 'Joining…' : 'Join'}</Button>
        </form>
        {join.error && <div className="mt-2 text-sm text-bad">{(join.error as ApiError).message}</div>}
      </Card>

      <section className="space-y-4">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-mut">Your classes</h2>
        {classes.isLoading ? (
          <Spinner />
        ) : (classes.data?.length ?? 0) === 0 ? (
          <EmptyNote>You haven't joined any classes yet. Enter a join code above.</EmptyNote>
        ) : (
          classes.data!.map((c) => <ClassTeams key={c.id} classId={c.id} name={c.name} simLength={c.simLength} />)
        )}
      </section>
    </div>
  );
}
